"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.Croquis = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var Croquis = function Croquis(props) {
  var largeurFixe = props.largeurFixe,
      tailleCote = props.tailleCote,
      hauteurMax = props.hauteurMax,
      doublo = props.doublo,
      product = props.product;
  var paddingCotes = 2;
  var couleurCotes = "#cc0331"; //Ratio entre la taille réelle des profils et la largeur désirée de l'image finale

  var ratio = (largeurFixe - tailleCote) / (product.ba_largeur + (doublo !== null ? doublo.ba_largeur : 0));

  if (product.ba_hauteur * ratio > hauteurMax) {
    ratio = hauteurMax / product.ba_hauteur;
  } //Calcul des largeurs des images rapportées au ratio


  var largeur = (product.ba_embase === null ? product.ba_largeur : product.ba_embase) * ratio;
  var hauteur = product.ba_hauteur * ratio;
  var largeurCM = doublo !== null ? doublo.ba_talon + (product.ba_embase === null ? product.ba_largeur : product.ba_embase) : product.ba_embase === null ? product.ba_largeur : product.ba_embase;
  var epaisseurCM = doublo !== null ? product.ba_hauteur - product.ba_hauteur_feuillure + doublo.ba_hauteur : product.ba_hauteur; //Styles

  var styleCroquis = {
    height: hauteur + tailleCote,
    marginBottom: 5,
    marginTop: 8
  };
  var styleImage = {
    left: tailleCote * 2,
    top: tailleCote,
    width: largeur,
    height: hauteur,
    position: "absolute"
  };
  var styleLargeurCote = {
    left: tailleCote * 2,
    top: "0px",
    width: largeurCM * ratio,
    height: tailleCote,
    lineHeight: tailleCote + "px",
    position: "absolute",
    borderStyle: "dashed solid none solid",
    borderWidth: "1px",
    borderColor: couleurCotes,
    textAlign: "center",
    overflow: "hidden"
  };
  var styleHauteurCote = {
    top: tailleCote,
    left: tailleCote,
    width: tailleCote,
    height: epaisseurCM * ratio,
    lineHeight: hauteur + "px",
    position: "absolute",
    borderStyle: "solid none solid dashed",
    borderWidth: "1px",
    borderColor: couleurCotes,
    textAlign: "left"
  };
  var styleCotes = {
    display: props.hideText ? "none" : "block",
    fontSize: "10px",
    fontWeight: "bold"
  };
  var styleTexteCotes = {
    padding: paddingCotes,
    color: couleurCotes
  };
  var styleTexteCotesHauteur = {
    padding: paddingCotes,
    color: couleurCotes,
    left: -64,
    textAlign: "right",
    width: 60,
    position: "absolute"
  };
  var styleImageDoublo;

  if (props.doublo !== null) {
    styleImageDoublo = {
      maxWidth: props.doublo.ba_largeur * ratio,
      maxHeight: props.doublo.ba_hauteur * ratio,
      position: "absolute",
      filter: "invert(59%) sepia(14%) saturate(5%) hue-rotate(12deg) brightness(88%) contrast(87%)",
      // https://codepen.io/sosuke/pen/Pjoqqp
      left: tailleCote + props.product.ba_talon * ratio,
      top: tailleCote + (hauteur - props.product.ba_hauteur_feuillure * ratio)
    };
  }

  var stylerehausse;

  if (props.rehausse !== null) {
    stylerehausse = {
      position: "absolute",
      maxWidth: 1.6 * ratio,
      maxHeight: (props.rehausse == 1 ? 1.6 : 2.2) * ratio,
      filter: "invert(59%) sepia(14%) saturate(5%) hue-rotate(12deg) brightness(88%) contrast(87%)",
      // https://codepen.io/sosuke/pen/Pjoqqp
      left: tailleCote + props.product.ba_talon * largeur / props.product.ba_largeur + 2,
      top: tailleCote + (props.product.ba_hauteur - props.product.ba_hauteur_feuillure) * hauteur / props.product.ba_hauteur + 15
    };
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    style: (0, _extends2.default)({}, styleCroquis, {
      width: 60 + largeur + tailleCote
    }),
    className: "is-relative",
    id: "croquis"
  }, /*#__PURE__*/_react.default.createElement("img", {
    style: styleImage,
    src: typeof product.croquis_svg !== "undefined" && product.croquis_svg !== null ? product.croquis_svg : product.croquis,
    alt: "croquis"
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: styleCotes
  }, /*#__PURE__*/_react.default.createElement("div", {
    style: styleLargeurCote
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: styleTexteCotes
  }, largeurCM.toFixed(2).replace(/(\.0|0)+$/, ""), " cm")), /*#__PURE__*/_react.default.createElement("div", {
    style: styleHauteurCote
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: styleTexteCotesHauteur
  }, epaisseurCM.toFixed(2).replace(/(\.0|0)+$/, ""), " cm"))), props.doublo !== null ? /*#__PURE__*/_react.default.createElement("img", {
    style: styleImageDoublo,
    src: props.doublo.croquis_svg !== null ? props.doublo.croquis_svg : props.doublo.croquis,
    alt: "croquis"
  }) : null, props.rehausse !== null && props.rehausse !== 0 ? /*#__PURE__*/_react.default.createElement("img", {
    src: "/img/rehausse.svg",
    style: stylerehausse,
    alt: "rehausse"
  }) : null), props.showHauteurFeuillure && !props.hideText && typeof product.ba_hauteur_feuillure !== 'undefined' && product.ba_hauteur_feuillure !== null ? /*#__PURE__*/_react.default.createElement("div", {
    style: (0, _extends2.default)({}, styleTexteCotes, {
      marginTop: props.doublo !== null ? 70 : 0
    })
  }, "Hauteur de feuillure : ", product.ba_hauteur_feuillure.toFixed(1), " cm") : null);
};

exports.Croquis = Croquis;
Croquis.defaultProps = {
  hideText: false,
  hauteurMax: 140
};
Croquis.propTypes = {
  product: _propTypes.default.object.isRequired,
  doublo: _propTypes.default.object,
  rehausse: _propTypes.default.number,
  largeurFixe: _propTypes.default.number,
  tailleCote: _propTypes.default.number,
  showHauteurFeuillure: _propTypes.default.bool,
  hideText: _propTypes.default.bool,
  hauteurMax: _propTypes.default.number
};
var _default = Croquis;
exports.default = _default;